import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';
import './atom-presale.css';

const AtomPresaleSection: React.FC = () => {
  // Refs para animaciones GSAP
  const containerRef = useRef<HTMLDivElement>(null);
  const titleRef = useRef<HTMLHeadingElement>(null);
  const stepsRef = useRef<HTMLDivElement>(null);
  const frameRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      // 1. Línea de tiempo principal
      const tl = gsap.timeline({
        defaults: { ease: "power3.out", duration: 1.2 },
        // Puedes agregar ScrollTrigger aquí si quieres que se active al hacer scroll
        // scrollTrigger: { trigger: containerRef.current, start: "top 70%" }
      });

      // 2. Animación del Título (Sale desde abajo)
      tl.to(titleRef.current, {
        y: 0,
        opacity: 1,
        duration: 1.5
      });

      // 3. Animación de los Pasos (Stagger: uno tras otro)
      // Seleccionamos los hijos directos del contenedor de pasos
      tl.to(".atom-step-item", {
        y: 0,
        opacity: 1,
        stagger: 0.2, // 0.2s de retraso entre cada paso
        duration: 1
      }, "-=1.0"); // Empieza un poco antes de que termine el título

      // 4. Aparición de la Dapp (Fade + Scale)
      tl.to(frameRef.current, {
        scale: 1,
        opacity: 1,
        duration: 1.5,
        ease: "expo.out"
      }, "-=1.5"); // Ocurre casi al mismo tiempo que el título

    }, containerRef);

    return () => ctx.revert(); // Limpieza al desmontar
  }, []);

  return (
    <section className="atom-presale-wrapper" ref={containerRef}>
      
      {/* Fondo de Puntos Animados Infinitos */}
      <div className="atom-presale-bg"></div>

      <div className="atom-presale-container">
        
        {/* --- LADO IZQUIERDO: INSTRUCCIONES --- */}
        <div className="atom-info-col">
          <h2 className="atom-presale-title" ref={titleRef}>
            SECURE YOUR<br />ALLOCATION.
          </h2>

          <div className="atom-steps-list" ref={stepsRef}>
            
            {/* Paso 1 */}
            <div className="atom-step-item">
              <span className="atom-step-number">01 / CONNECT</span>
              <div className="atom-step-content">
                <h3>Link Wallet</h3>
                <p>Ensure you are on the supported network. Use MetaMask or WalletConnect for a secure link.</p>
              </div>
            </div>

            {/* Paso 2 */}
            <div className="atom-step-item">
              <span className="atom-step-number">02 / SELECT</span>
              <div className="atom-step-content">
                <h3>Choose Amount</h3>
                <p>Input the amount of ETH or USDT you wish to exchange. Verify the gas fees before proceeding.</p>
              </div>
            </div>

            {/* Paso 3 */}
            <div className="atom-step-item">
              <span className="atom-step-number">03 / CONFIRM</span>
              <div className="atom-step-content">
                <h3>Execute Swap</h3>
                <p>Approve the transaction in your wallet. Wait for the network confirmation block.</p>
              </div>
            </div>

          </div>
        </div>

        {/* --- LADO DERECHO: DAPP CONTAINER --- */}
        <div className="atom-dapp-col">
          <div className="atom-dapp-frame" ref={frameRef}>
            {/* Esquinas decorativas tecnológicas */}
            <div className="atom-corner c-tl"></div>
            <div className="atom-corner c-tr"></div>
            <div className="atom-corner c-bl"></div>
            <div className="atom-corner c-br"></div>

            {/* AQUÍ VA TU IFRAME */}
            {/* Reemplaza 'src' con la URL real de tu Dapp desplegada */}
            <iframe 
              src="https://app.uniswap.org" 
              className="atom-dapp-iframe"
              title="Atom Presale Dapp"
              loading="lazy"
            ></iframe>
          </div>
        </div>

      </div>
    </section>
  );
};

export default AtomPresaleSection;